import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useFeira } from '../../Contexts/FeiraContext';
import { motion, AnimatePresence } from 'framer-motion';
import LegendaCores from "../../Components/Common/LegendaCores";
import SidebarEstande2 from "../../Layouts/SidebarEstandes";
import { Col, Row} from "reactstrap";
import MapaVisualizadorMobile from '../../Components/Common/MapaIndependenteMobile';
import { debounce } from 'lodash';
import '../../MeuSCSS/telaMapaMobile.scss';
import BannerVendas from '../../Components/Common/Banner';
import Loading from '../../Components/Common/Loading';

const TelaMapaFeiraMobile = () => {
  const {
    corPrincipal,
    mostrarFiltros,
    setMostrarFiltros,
    dadosProntos,
    mapLoading,
    handleAplicarFiltros,
    handleRemoverFiltros,
    modoRenovacao,
    corRenovacao,
    corLivre,
    corReservado,
    corVendido,
    banner, 
    bannerMobile,
    isMobile,
    filtros,
    setFiltros,
    logoDesenvolvedorMapa,
    filteredHashes,
    corPendenteRenovacao
  } = useFeira();

  const mapaRef = useRef(null);
  
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);
    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  const updateFilters = useCallback(
    debounce((newFilters) => {
      setFiltros(newFilters);
    }, 300),
    [setFiltros]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    const newFilters = {
      ...filtros,
      [name]: value
    };
    
    updateFilters(newFilters);
  };

  const parseCurrencyInput = (value) => {
    return parseFloat(value.replace(/[^\d,-]/g, '').replace(',', '.')) || 0;
  };

  const headerHeight = isLandscape ? 100 : 130;
  const headerHeightMapa = isLandscape ? headerHeight + 20 : 130;

  const aplicarFocoNosFiltros = useCallback(() => {
    if (!mapaRef.current || !filteredHashes || filteredHashes.size === 0) return;
    
    setTimeout(() => {
      if (mapaRef.current && mapaRef.current.focusOnElements) {
        const success = mapaRef.current.focusOnElements(Array.from(filteredHashes), 100);
        console.log("Foco aplicado com focusOnElements:", success);
      } 
      else if (mapaRef.current && mapaRef.current.resetZoom) {
        mapaRef.current.resetZoom();
        console.log("Foco aplicado com resetZoom");
      }
      else {
        console.log("Métodos de foco não disponíveis, disparando evento resize");
        // window.dispatchEvent(new Event('resize'));
        if (mapaRef.current && mapaRef.current.resize) {
            mapaRef.current.resize();
        }
      }
    }, 600);
  }, [filteredHashes]);

  const handleAplicarFiltrosComReset = async () => {
    await handleAplicarFiltros();
    setMostrarFiltros(false);
    
    setTimeout(() => {
      if (filteredHashes && filteredHashes.size > 0) {
        aplicarFocoNosFiltros();
      } else {
        if (mapaRef.current && mapaRef.current.resetZoom) {
          mapaRef.current.resetZoom();
        }
      }
    }, 800);
  };
  
  const handleRemoverFiltrosComReset = async () => {
    await handleRemoverFiltros();
    
    setTimeout(() => {
      if (mapaRef.current && mapaRef.current.resetZoom) {
        mapaRef.current.resetZoom();
      }
    }, 500);
  };

  useEffect(() => {
    if (filteredHashes && filteredHashes.size > 0) {
      const timer = setTimeout(() => {
        aplicarFocoNosFiltros();
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [filteredHashes, aplicarFocoNosFiltros]);

    
  const MobileHeader = () => (
    <div style={{
      width: '100%',
      backgroundColor: 'white',
      zIndex: 1000
    }}>
      <BannerVendas/>
      
      <div style={{
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
      }}>
        <Col sm={1}>
          <button 
              onClick={() => setMostrarFiltros(!mostrarFiltros)}
              style={{ background: 'none', border: 'none', color: corPrincipal }}>
            <i className="ri-filter-line" style={{ fontSize: '20px' }}></i>
          </button>
        </Col>

        <Col sm={10} style={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <LegendaCores
            corLivre={corLivre}
            corReservado={corReservado}
            corVendido={corVendido}
            corRenovacao={corRenovacao}
            exibeRenovacao={modoRenovacao}
            corPendenteRenovacao={corPendenteRenovacao}
            textoLivre="Disponível"
            textoReservado="Reservado"
            textoVendido="Vendido"
            tamanhoQuadrado={15}
            espacamento={5}
          />
         
        </Col>
      </div>

  
    </div>
  );

  if (!dadosProntos || mapLoading) {
    return (
      <Loading fullScreen={false} size={48} bgColor="rgba(255,255,255,0.8)" />
    );
  }

  return (
    <div style={{ width: '100vw', height: '100dvh', overflow: 'hidden', padding: '15px', touchAction: 'none' }}>
      <Row style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        minHeight: `${headerHeight}px`,
        zIndex: 1000,
        backgroundColor: 'white'
      }}>
        <MobileHeader />
      </Row>

      <Row style={{
        marginTop: `${headerHeightMapa}px`,
        height: `calc(100dvh - ${headerHeightMapa}px)`,
        position: 'relative',
        touchAction: 'none'
      }}>
        <MapaVisualizadorMobile ref={mapaRef}
          filteredHashes={filteredHashes}
          onFilterChange={aplicarFocoNosFiltros} />
        {
          logoDesenvolvedorMapa && (
            <img src={logoDesenvolvedorMapa} alt="Logo do Desenvolvedor" style={{
              position: 'fixed',
              width: isLandscape ? '5%' : '15%',
              bottom: '10px',
              right: '10px',
              zIndex: 9999
            }} />
          )
        }
      </Row>

      <SidebarEstande2 />

      <AnimatePresence>
        {mostrarFiltros && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            background: "rgba(255, 255, 255, 0.95)",
            overflowY: 'auto',
            padding: "16px"
          }}>
         
          <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="modal-filtros bg-white shadow-lg p-4 rounded-lg w-full"
              style={{ 
              maxHeight: isMobile ? "90vh" : "80vh",
              overflowY: "auto",
              }}>
                <div
                className="mb-3"
                style={{
                    display: "flex",
                    flexDirection: "column",
                }}
                >
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                    onClick={() => setMostrarFiltros(false)}
                    className="btn btn-link btn-sm"
                    style={{
                        fontSize: "18px",
                        color: "#333",
                        textDecoration: "none"
                    }}
                    aria-label="Fechar filtros"
                    >
                    <i className="ri-close-line"></i>
                    </button>
                </div>

                <label
                    style={{
                    color: "#495057",
                    fontSize: "14px",
                    }}
                    className="block text-sm font-semibold"
                >
                    Valor do Espaço
                </label>
                <div
                    style={{
                    display: "flex",
                    alignItems: "center",
                    }}
                    className="flex gap-2"
                >
                    <input
                    type="text"
                    name="valorMin"
                    value={filtros.valorMin}
                    onChange={handleChange}
                    onBlur={(e) => {
                        const parsedValue = parseCurrencyInput(e.target.value);
                        setFiltros(prev => ({ ...prev, valorMin: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="R$ 1.500,00"
                    style={{ width: "100%", borderRadius: "5px" }}
                    />
                    <p
                    style={{
                        marginBottom: 0,
                        color: "rgba(73, 80, 87)",
                    }}
                    >
                    até
                    </p>
                    <input
                    type="text"
                    name="valorMax"
                    value={filtros.valorMax}
                    onChange={handleChange}
                    onBlur={(e) => {
                        const parsedValue = parseCurrencyInput(e.target.value);
                        setFiltros(prev => ({ ...prev, valorMax: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="R$ 1.500,00"
                    style={{ width: "100%", borderRadius: "5px" }}
                    />
                </div>
                </div>

                <div className="mb-3">
                <label
                    style={{
                    color: "#495057",
                    fontSize: "14px",
                    }}
                    className="block text-sm font-semibold"
                >
                    Altura
                </label>
                <div
                    style={{
                    display: "flex",
                    }}
                    className="flex gap-2"
                >
                    
                    <input
                    type="text"
                    name="alturaMin"
                    value={filtros.alturaMin}
                    onChange={handleChange}
                    onBlur={(e) => {
                        const parsedValue = parseCurrencyInput(e.target.value);
                        setFiltros(prev => ({ ...prev, alturaMin: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Min"
                    style={{ width: "100%", borderRadius: "5px" }}
                    />
                    <input
                    type="text"
                    name="alturaMax"
                    value={filtros.alturaMax}
                    onChange={handleChange}
                    onBlur={(e) => {
                        const parsedValue = parseCurrencyInput(e.target.value);
                        setFiltros(prev => ({ ...prev, alturaMax: parsedValue }));
                    }}
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Max"
                    style={{ width: "100%", borderRadius: "5px" }}
                    />
                </div>
                </div>

                <div className="mb-3">
                <label
                    style={{
                    color: "#495057",
                    fontSize: "14px",
                    }}
                    className="block text-sm font-semibold"
                >
                    Área Total
                </label>
                <div
                  style={{
                  display: "flex",
                  }}
                  className="flex gap-2">
                    <input
                      type="text"
                      name="areaMin"
                      value={filtros.areaMin}
                      onChange={handleChange}
                      onBlur={(e) => {
                          const parsedValue = parseCurrencyInput(e.target.value);
                          setFiltros(prev => ({ ...prev, areaMin: parsedValue }));
                      }}
                      className="w-full border rounded-lg p-2 mt-1"
                      placeholder="Min"
                      style={{ width: "100%", borderRadius: "5px" }}
                    />
                    <input
                      type="text"
                      name="areaMax"
                      value={filtros.areaMax}
                      onChange={handleChange}
                      onBlur={(e) => {
                          const parsedValue = parseCurrencyInput(e.target.value);
                          setFiltros(prev => ({ ...prev, areaMax: parsedValue }));
                      }}
                      className="w-full border rounded-lg p-2 mt-1"
                      placeholder="Max"
                      style={{ width: "100%", borderRadius: "5px" }}
                    />
                </div>
                </div>

                <div className="mb-3">
                  <label
                    style={{
                    color: "#495057",
                    fontSize: "14px",
                    }}
                    className="block text-sm font-semibold">
                    Nome
                  </label>
                  <div
                    style={{
                    display: "flex",
                    }}
                    className="flex gap-2">
                      <input
                        type="text"
                        name="nome"
                        value={filtros.nome}
                        onChange={handleChange}
                        onBlur={(e) => {
                          setFiltros(prev => ({ ...prev, nome: e.target.value }));
                        }}
                        className="w-full border rounded-lg p-2 mt-1"
                        placeholder="nome do espaço, expositor ..."
                        style={{ width: "100%", borderRadius: "5px" }}
                      />
                  </div>
                </div>

                <div className="gap-2" style={{ display: "flex" }}>
                <button
                    style={{ width: "100%" }}
                    onClick={handleAplicarFiltrosComReset}
                    type="button"
                    className="btn btn-soft-primary waves-effect waves-light shadow-none"
                >
                    Aplicar
                </button>
                <button
                    style={{ width: "100%" }}
                    onClick={handleRemoverFiltrosComReset}
                    type="button"
                    className="btn btn-ghost-danger waves-effect waves-light shadow-none"
                >
                    Remover
                </button>
                </div>
            </motion.div>

            <button onClick={() => setMostrarFiltros(false)} className="btn btn-danger">Fechar</button>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TelaMapaFeiraMobile;
